import {
  isBicForbidden,
  isIbanMatchingCountry,
  isSwiftBicMatchingCountry,
} from '@shinetools/iban-bban-bic';
import { z } from 'zod';

import zodLocales from 'common/zod/locales';
import { ibanSchema, swiftBicSchema } from 'common/zod/schemas';

import locales from './locales';

export const recipientInformationFormSchema = z
  .object({
    country: z.string().min(1, { message: zodLocales.errors.required }),

    iban: ibanSchema,

    name: z.string().trim().min(1, { message: zodLocales.errors.required }),

    swiftBic: swiftBicSchema,
  })

  .superRefine(({ country: countryCode, iban, swiftBic }, ctx) => {
    if (!isSwiftBicMatchingCountry({ countryCode, swiftBic })) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: locales.errors.swiftBicNotMatchingCountry,
        path: ['swiftBic' satisfies keyof RecipientInformationFormSchema],
      });
    }

    if (isBicForbidden(swiftBic)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: locales.errors.forbiddenBic,
        path: ['swiftBic' satisfies keyof RecipientInformationFormSchema],
      });
    }

    if (!isIbanMatchingCountry({ countryCode, iban })) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: locales.errors.ibanNotMatchingCountry,
        path: ['iban' satisfies keyof RecipientInformationFormSchema],
      });
    }
  });

export type RecipientInformationFormSchema = z.infer<
  typeof recipientInformationFormSchema
>;
